import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ProgrammingUtilsService } from '../services/utils.service';

@Injectable()
export class RequiresBackupGuard implements CanActivate, CanActivateChild {

  constructor(
    private utils: ProgrammingUtilsService,
    private store: Store<any>,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let obs = this.store.select(s => !!s.backup && s.backup.checked)
      .filter(c => !!c)
      .flatMap(c => this.store.select(s => !s.backup.required));

    obs.subscribe(hasRecentBackup => {
      if (!hasRecentBackup) {
        console.log('guard: routing to backup');
        let path = state.url.substring(0, state.url.indexOf('programming')) + 'backup';
        console.log('guard: backup url', path);

        let qsindex = state.url.indexOf('?');
        let redirect = (qsindex >= 0) ? state.url.substring(0, qsindex) : state.url;

        console.log('guard: redirect url: ', redirect);

        this.router.navigate([path, { origin: redirect }]);
      }
    });

    return obs;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.canActivate(next, state);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/guards/requires-backup.guard.ts